import { Box, Col, Container, Heading, Row, Text } from '@dbi-tools/ui-kit';
import { PreloadImage } from '@dbi-tools/ui-kit/lib/preload-image';
import PrivacyPolicyText from '@quiz-frontend/quiz-builder/components/common/privacy-policy-text';
import React from 'react';

import { Question } from '../../types';
import StepsCounter from '../common/steps-counter';
import QuestionLayout from '../questions/question.layout';
import { ThumbnailImg } from './styled/complex.styled';
import { MainWhiteStyled } from './styled/main.styled';

const FormStepLayout: React.FC<{
  questions: Question[];
  title: string;
  image: string;
}> = ({ questions, title, image }) => {
  return (
    <Container>
      <MainWhiteStyled>
        <Row>
          <Col lg={8}>
            <StepsCounter />
            <Heading as="h1" measure={{ xs: 'h4', md: 'h3' }} mb={15}>
              {title}
            </Heading>
            <Text>
              Enter your <b>name and email</b> to view your personalized vision board
            </Text>
            <Row>
              {questions &&
                questions.map((question, i) => (
                  <Col md={i < questions.length - 1 ? 6 : 12} key={question.id}>
                    <QuestionLayout question={question} />
                  </Col>
                ))}
            </Row>
            <PrivacyPolicyText />
          </Col>
          <Col lg={4}>
            <Box display={{ xs: 'none', lg: 'block' }} mr={-60}>
              <ThumbnailImg>
                <PreloadImage src={image} alt={title} />
              </ThumbnailImg>
            </Box>
          </Col>
        </Row>
      </MainWhiteStyled>
    </Container>
  );
};

export default FormStepLayout;
